<div class="gc-root" *ngIf="isReady">
  <button class="gc-trigger" (click)="toggle($event)" [class.open]="isOpen"
          [title]="'Organization & channel'" aria-haspopup="true" [attr.aria-expanded]="isOpen">
    <span class="gc-dot">{{ orgInitials }}</span>
    <span class="gc-label">
      <b>{{ selectedOrg?.Name || 'Select organization' }}</b>
      <ng-container *ngIf="selectedChannel"> · {{ selectedChannel.Name }}</ng-container>
    </span>
    <i class="fa-solid fa-chevron-down gc-chev"></i>
  </button>

  <div class="gc-pop" *ngIf="isOpen">
    <div class="gc-group">
      <div class="gc-group-label">Organization</div>
      <button class="gc-item" *ngFor="let org of organizations"
              [class.on]="org.ID === selectedOrg?.ID"
              (click)="selectOrg(org)">
        <span class="gc-item-dot">{{ initialsFor(org.Name) }}</span>
        <span class="gc-item-name">{{ org.Name }}</span>
        <i class="fa-solid fa-check gc-check" *ngIf="org.ID === selectedOrg?.ID"></i>
      </button>
    </div>
    <div class="gc-group" *ngIf="channels.length > 0">
      <div class="gc-group-label">Channel</div>
      <button class="gc-item" *ngFor="let ch of channels"
              [class.on]="ch.ID === selectedChannel?.ID"
              (click)="selectChannel(ch)">
        <span class="gc-item-name">{{ ch.Name }}</span>
        <i class="fa-solid fa-check gc-check" *ngIf="ch.ID === selectedChannel?.ID"></i>
      </button>
    </div>
  </div>
</div>
